import { createSlice } from "@reduxjs/toolkit"

export const topSellingProductListSlice = createSlice({
	name: "topSelling_list",
	initialState: {
		topSelling: "",
		errors: [],
	},

	reducers: {
        getTopSelling: (state, action) => {
          
			state.topSelling = action.payload
		},
		getTopSellingList: (state, action) => {
          
			state.topSelling = action.payload
		},
		getErrors: (state, action) => {
			state.errors = action.payload
		},
	},
})
export const {getTopSelling, getTopSellingList, getErrors} = topSellingProductListSlice.actions

export default topSellingProductListSlice.reducer
